import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardWithHeader } from '../../../../ui/CardWithHeader';
import { ScatterChart } from '../ScatterChart';
import { HydratedScatterBlock } from '../../../../../services/admin/cloudAgentTypes';
import { BlockSourceNote } from './BlockSourceNote';

/** scatter → ScatterChart (dumb) inside a titled card. */
export const ScatterBlock: React.FC<{ block: HydratedScatterBlock }> = ({ block }) => {
  const { t } = useTranslation();
  return (
    // Own horizontal scroller: the plot must never widen the page on mobile.
    <div className="overflow-x-auto">
      <CardWithHeader title={block.title ?? t('cloudAgent.blockTitles.scatter')}>
        <ScatterChart
          points={block.data.points}
          xLabel={block.data.xLabel}
          yLabel={block.data.yLabel}
          emptyText={t('common.noDataInPeriod')}
        />
      </CardWithHeader>
      <BlockSourceNote source={block.source} />
    </div>
  );
};
